import React, { useEffect, useState } from "react"
import TextField from "@mui/material/TextField"
import { useSearchParams } from "react-router-dom"
import DataTableSearchBarFilter from "./DataTableSearchBarFilters"
import { Box } from "@mui/material"
import CustomTextField from "../../../../../components/core/CustomTextField/CustomTextField"

const DataTableSearchBar = ({ getData, filters = [] }) => {
  const [searchTerm, setSearchTerm] = useState("")
  let [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    setSearchTerm(searchParams.get("search") || "")
  }, [])

  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      bgcolor: "rgba(255,255,255,0.05)",
      borderRadius: 1,
      "& fieldset": { borderColor: "#1e2d3d" },
      "&:hover fieldset": { borderColor: "#c9a84c" },
      "&.Mui-focused fieldset": { borderColor: "#c9a84c" },
    },
    "& .MuiOutlinedInput-input": { color: "#f0ede8", fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.8rem" },
    "& .MuiInputLabel-root": { color: "#8a9bb0", fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.75rem" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#c9a84c" },
    "& .MuiSelect-icon": { color: "#8a9bb0" },
  }

  return (
    <Box px={2} py={1}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
        <CustomTextField
          label="Search"
          variant="outlined"
          size="small"
          fullWidth
          value={searchTerm}
          sx={fieldSx}
          onChange={(event) => {
            setSearchTerm(event.target.value)
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault()
              searchParams.set("search", searchTerm)
              setSearchParams(searchParams)
              getData(1, searchTerm)
            }
          }}
        />
        {filters.map((filter) => {
          return (
            <DataTableSearchBarFilter
              key={filter.title_key}
              filter={filter}
              getData={getData}
              searchTerm={searchTerm}
              fieldSx={fieldSx}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default DataTableSearchBar
